import type { StateCreator } from 'zustand'

import { AppInitPhase } from './app-init.const'
import { appInitInitialState } from './app-init.slice'
import type { AppInitStore, AppInitStoreSyncActions } from './app-init.type'

type AppInitSet = Parameters<StateCreator<AppInitStore, [['zustand/immer', never]], [], AppInitStore>>[0]

export const createAppInitActions = (set: AppInitSet): AppInitStoreSyncActions => ({
  reset: () =>
    set(() => ({
      ...appInitInitialState,
    })),
  markBlockedUnverified: () =>
    set((state) => {
      state.phase = AppInitPhase.BlockedUnverified
      state.hasInitialized = true
      state.error = null
    }),
  markPipelineStarted: () =>
    set((state) => {
      state.pipelineStarted = true
    }),
  setPhase: (phase) =>
    set((state) => {
      state.phase = phase
    }),
  setHasInitialized: (hasInitialized) =>
    set((state) => {
      state.hasInitialized = hasInitialized
    }),
  setError: (error) =>
    set((state) => {
      state.error = error
    }),
})
